import { Injectable } from '@angular/core';
import { AnyLoc } from 'src/generated-sources';
import { ItemsDataFetcherService } from '../items-data-fetcher.service';

@Injectable()
export abstract class ImagesDataFetcherService extends ItemsDataFetcherService {
    abstract getImagePath(itemId: string): string;
}
